import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

/** sessionStorage key holding the referral code captured from /r/:code. */
export const REFERRAL_CODE_KEY = 'referral_code';

/**
 * Landing target for referral links (`uptal.com/r/<code>`). Persists the code
 * to sessionStorage so it survives navigation within this tab, then redirects
 * to the homepage. No UI — the redirect is immediate.
 */
@Component({
  selector: 'app-referral-redirect',
  template: '',
})
export class ReferralRedirectComponent implements OnInit {
  private readonly isBrowser: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    const code = (this.route.snapshot.paramMap.get('code') || '').trim();
    if (this.isBrowser && code) {
      try {
        sessionStorage.setItem(REFERRAL_CODE_KEY, code);
      } catch {
        /* private-mode / disabled storage — referral simply isn't forwarded */
      }
    }
    this.router.navigate(['auto-apply']);
  }
}
